import { Injectable, inject, signal } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TenantConfigService } from '../../../config/tenant-config';
import { firstValueFrom, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { PLATFORM_API_URL } from '../../../config/api-config';

@Injectable({
    providedIn: 'root',
})
export class AutoComplete {
    private http = inject(HttpClient);
    private tenantConfig = inject(TenantConfigService);

    public isLoading = signal<boolean>(false);

    getCityState(zipCode: string): Observable<any> {
        const websiteId = this.tenantConfig.settings?.['websiteId'];
        const headers = new HttpHeaders({
            'X-Tenant': websiteId ? websiteId.toString() : '',
        });

        const body = {
            tenant: websiteId ? websiteId.toString() : ''
        };

        return this.http.post<any>(
            `${PLATFORM_API_URL}/order-form/get-city-state/${zipCode}`,
            body,
            { headers }
        );
    }

    autoCompleteUserData(zipCode: string, email: string): Observable<any> {
        this.isLoading.set(true);
        const websiteId = this.tenantConfig.settings?.['websiteId'];
        const headers = new HttpHeaders({
            'X-Tenant': websiteId ? websiteId.toString() : '',
        });

        const body = {
            tenant: websiteId ? websiteId.toString() : '',
            zipcode: zipCode,
            email: email,
        };

        return this.http.post<any>(
            `${PLATFORM_API_URL}/order-form/get-user-info`,
            body,
            { headers }
        ).pipe(
            finalize(() => this.isLoading.set(false))
        );
    }
}
